<template>
 
    <rect x="24" y="95" width="80" height="24" rx="4"      
    class="c1"  
    fill="transparent" stroke-width="5"/>
    <line class="c1" x1="28" y1="95" x2="28" y2="60" stroke-width="5" />
    <line class="c1" x1="100" y1="95" x2="100" y2="60" stroke-width="5" />
    
    <line class="c1" x1="20" y1="95" x2="108" y2="95" stroke-width="5"/>

    <path class="c1" fill="transparent" d="M 24 60 L 64 36 L 104 60 Z" stroke-width="5" />
       
    <line class="c1" x1="64" y1="36" x2="36" y2="60" stroke-width="4"/>
    <line class="c1" x1="64" y1="36" x2="48" y2="60" stroke-width="4"/>
    <line class="c1" x1="64" y1="36" x2="60" y2="60" stroke-width="4"/>
    <line class="c1" x1="64" y1="36" x2="68" y2="60" stroke-width="4"/>
    <line class="c1" x1="64" y1="36" x2="80" y2="60" stroke-width="4"/>
    <line class="c1" x1="64" y1="36" x2="92" y2="60" stroke-width="4"/>

    <path class="c2" d="M 24 60 M 24 60 C 24 64, 32 64, 32 60 C 32 64, 40 64, 40 60 C 40 64, 48 64, 48 60 
      C 48 64, 56 64, 56 60 C 56 64, 64 64, 64 60 C 64 64, 72 64, 72 60 C 72 64, 80 64, 80 60 
      C 80 64, 88 64, 88 60 C 88 64, 96 64, 96 60 C 96 64, 104 64, 104 60" 
    />

</template>

<script>
export default {
   props: {
    iconColor: {
      type: String,
      required: false,
      default: 'black',
    },
    iconBorder: {
      type: String,
      required: false,
      default: 'black',
    },
   },   
};
</script>

<style scoped>
    path {
        font-family: var(--iconFontFamily);
        font-size: var(--iconFontSize);        
    }

    .c2 {
      fill:var(--iconColor)
    }

    .c1 {
      stroke:var(--iconColor)
    }

    .group:hover .group-hover\:text-hoverIcon  .c2{
      fill:var(--iconHoberColor)
    }

    .group:hover .group-hover\:text-hoverIcon  .c1 {
      stroke:var(--iconHoberColor)
    }
</style>